import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  role: "list",
  class: "flex flex-1 flex-col"
}
const _hoisted_2 = {
  key: 0,
  class: "last:mt-auto"
}
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = {
  key: 0,
  class: "ml-2 text-gray-400 transition-colors duration-150 hover:text-white"
}
const _hoisted_5 = {
  key: 1,
  class: "last:mt-auto"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "ml-2 text-gray-400 transition-colors duration-150 hover:text-white"
}
const _hoisted_8 = ["hidden"]

import { ref, computed, watch, type Ref } from 'vue';
import { useRoute } from 'vue-router';
import { ChevronRightIcon, QuestionMarkCircleIcon } from '@heroicons/vue/outline';

import { useFilterStore, useAuraStore } from '@/stores';
import { can } from '@/composables/useAuth';

import { type NavigationItem, type LevelModel } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'TemplateNavigation',
  props: {
    items: {
        type: Array as () => NavigationItem[],
        default: () => [],
    },
},
  setup(__props) {

const route = useRoute();
const filterStore = useFilterStore();
const auraStore = useAuraStore();

const props = __props;

const filteredNavigationItems: Ref<NavigationItem[]> = ref([]);

const levelFilter = computed<LevelModel | null>(() => filterStore.level);

const isActive = (item: NavigationItem) => {
    if (item.name === 'Home') {
        return route.name === item.name;
    } else {
        return route.matched.some(({ name }) => {
            if (typeof name !== 'string') return false;
            return name === item.name || item.activateBy?.includes(name);
        });
    }
};

const hasActiveChildren = (item: NavigationItem) =>
    (item.children || []).some((i: NavigationItem) => isActive(i));

const toggleVisibility = (item: NavigationItem) => {
    item.isOpen = !item.isOpen;
};

let navigationRefreshSequence = 0;

const updateNavigationItems = () => {
    filteredNavigationItems.value = props.items
        .map((item) => {
            return !item.children?.length
                ? item
                : {
                      ...item,
                      children: item.children.filter(
                          (child) => !child.permission || can(child.permission),
                      ),
                  };
        })
        .filter((item, index) => {
            if (item.localeKey === 'sideNavigation.meet.group' && !levelFilter.value?.meeting) {
                return false;
            }
            if (item.localeKey === 'sideNavigation.aura' && auraStore.isAuraEnabled !== true) {
                return false;
            }
            return props.items[index].children?.length === undefined
                ? !item.permission || can(item.permission)
                : item.children?.length;
        });
};

const refreshNavigation = async () => {
    const refreshSequence = ++navigationRefreshSequence;
    const contextRequest = auraStore.checkContext();
    updateNavigationItems();
    await contextRequest;
    if (refreshSequence !== navigationRefreshSequence) return;
    updateNavigationItems();
};

watch(() => levelFilter.value?.id, refreshNavigation, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredNavigationItems.value, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.name
      }, [
        (!item.children && item.name)
          ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: {
                        name: item.name,
                        query: item.query,
                    },
                class: _normalizeClass([
                        isActive(item)
                            ? 'bg-indigo-900/70 text-white'
                            : 'text-gray-400 hover:bg-indigo-900/70 hover:text-white',
                        'group flex w-full items-center py-2 font-medium',
                    ])
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                    class: _normalizeClass([
                            isActive(item)
                                ? 'text-secondary'
                                : 'group-hover:text-secondary text-gray-400',
                            'ml-2 h-6 w-6 flex-shrink-0',
                        ]),
                    "aria-hidden": "true"
                  }, null, 8, ["class"])),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(item.localeKey)), 1),
                  (item.tooltip)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createVNode(_unref(QuestionMarkCircleIcon), {
                          class: "h-4 w-4 cursor-help",
                          "aria-hidden": "true"
                        })
                      ])), [
                        [_directive_tippy, { content: _ctx.$t(item.tooltip), allowHTML: true }]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            ]))
          : (_openBlock(), _createElementBlock("li", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "group flex w-full items-center rounded py-2 pl-2 pr-1 text-left font-medium text-gray-400 hover:bg-indigo-900/70 hover:text-white",
                  onClick: ($event: any) => (toggleVisibility(item))
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                    class: _normalizeClass([
                                hasActiveChildren(item) || item.isOpen ? 'text-secondary' : '',
                                'mr-3 h-6 w-6 flex-shrink-0 text-gray-400 group-hover:text-[#6dbcab]',
                            ]),
                    "aria-hidden": "true"
                  }, null, 8, ["class"])),
                  _createElementVNode("span", {
                    class: _normalizeClass([
                                hasActiveChildren(item) || item.isOpen ? 'text-white' : '',
                                'flex-1',
                            ])
                  }, _toDisplayString(_ctx.$t(item.localeKey)), 3),
                  (item.tooltip)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _createVNode(_unref(QuestionMarkCircleIcon), {
                          class: "h-4 w-4 cursor-help",
                          "aria-hidden": "true"
                        })
                      ])), [
                        [_directive_tippy, { content: _ctx.$t(item.tooltip), allowHTML: true }]
                      ])
                    : _createCommentVNode("", true),
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass([
                                hasActiveChildren(item) || item.isOpen
                                    ? 'rotate-90 text-gray-400'
                                    : 'text-gray-300',
                                'ml-4 h-5 w-5 flex-shrink-0 transform transition-colors duration-150 ease-in-out group-hover:text-gray-400',
                            ]),
                    viewBox: "0 0 20 20",
                    "aria-hidden": "true"
                  }, _cache[0] || (_cache[0] = [
                    _createElementVNode("path", {
                      d: "M6 6L14 10L6 14V6Z",
                      fill: "currentColor"
                    }, null, -1)
                  ]), 2))
                ], 8, _hoisted_6),
                _createElementVNode("ul", {
                  class: "mt-1",
                  id: "sub-menu-1",
                  hidden: !(hasActiveChildren(item) || item.isOpen)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subItem, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createVNode(_component_router_link, {
                        to: {
                                    name: subItem.name,
                                    query: subItem.query,
                                },
                        href: "#",
                        class: _normalizeClass([
                                    isActive(subItem)
                                        ? 'bg-indigo-900/70 text-white'
                                        : 'text-gray-400 hover:bg-indigo-900/70 hover:text-white',
                                    'group flex w-full items-center py-2 pl-2 font-medium',
                                ])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ChevronRightIcon), {
                            class: "mr-1 h-4 w-4",
                            "aria-hidden": "true"
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t(subItem.localeKey)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class"])
                    ]))
                  }), 128))
                ], 8, _hoisted_8)
              ])
            ]))
      ], 64))
    }), 128))
  ]))
}
}

})